import React from 'react';
import PropTypes from 'prop-types';

import './index.css';

// left/center/right nav using bulma .level
const LevelNav = ({ nav, hideRightIcon }) => {
  return (
    <ul className={'level level-nav is-flex'} role="navigation">
      <li className={'level-left'}>
        {nav.left && nav.left.label && (
          <a
            onClick={nav.left.action}
            className={'chevron chevron--left chevron--invert'}
          >
            {nav.left.label}
          </a>
        )}
        {nav.left && nav.left.element}
      </li>
      <li className={'level-center'}>
        {nav.center && <h1 className={'h5'}>{nav.center.label}</h1>}
      </li>
      <li className={'level-right'}>
        {nav.right && nav.right.label && (
          <a
            onClick={nav.right.action}
            className={
              hideRightIcon ? '' : 'chevron chevron--right chevron--invert'
            }
          >
            {nav.right.label}
          </a>
        )}
        {nav.right && nav.right.element}
      </li>
    </ul>
  );
};

LevelNav.propTypes = {
  nav: PropTypes.object,
  hideRightIcon: PropTypes.bool,
};

export default LevelNav;



// WEBPACK FOOTER //
// ./src/common/components/LevelNav/index.js